import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { GlowOrb } from '../components/GlowOrb';
import { Moon, Star, Compass } from 'lucide-react';
export function NotFound() {
  return <div className="min-h-[80vh] flex items-center justify-center relative overflow-hidden py-24" data-id="element-771">
      <GlowOrb color="primary" size="xl" position="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-772" />

      <div className="container mx-auto px-6 text-center relative z-10" data-id="element-773">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="max-w-2xl mx-auto glass p-12 md:p-20 rounded-[3rem]" data-id="element-774">
          <div className="relative w-32 h-32 mx-auto mb-8" data-id="element-775">
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 20,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 border-2 border-dashed border-gold/30 rounded-full" data-id="element-776" />
            <Moon className="w-16 h-16 text-gold absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-777" />
          </div>

          <h1 className="text-6xl md:text-8xl font-serif text-white mb-4" data-id="element-778">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-serif text-gold mb-6" data-id="element-779">
            The Cosmic Path is Unclear
          </h2>
          <p className="text-beige-muted text-lg mb-10 max-w-md mx-auto" data-id="element-780">
            The sacred page you are searching for has shifted in the energetic
            realm. Let us guide you back to alignment.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-781">
            <Button href="/" variant="primary" icon={<Star className="w-4 h-4" data-id="element-783" />} data-id="element-782">
              Return Home
            </Button>
            <Button href="/services" variant="glass" icon={<Compass className="w-4 h-4" data-id="element-785" />} data-id="element-784">
              Explore Services
            </Button>
          </div>
        </motion.div>
      </div>
    </div>;
}